// components/PayUForm.jsx
import React, { useEffect, useRef } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import swal from 'sweetalert';

const PayUForm = ({ formData, autoSubmit = false }) => {
  const hasOpened = useRef(false);

  useEffect(() => {
    if (!autoSubmit || hasOpened.current) return;

    if (!window.Razorpay) {
      console.error("Razorpay SDK not loaded");
      return;
    }

    hasOpened.current = true;

    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY_ID, // public key
      amount: formData.amount * 100,
      currency: "INR",
      name: "Pargati Online Services",
      description: "Recharge",
      order_id: formData.txnid,
      handler: async function (res) {
        try {
          const payuLikeResponse = {
            txnid: formData.txnid,                     // same txn id you generated
            mihpayid: res.razorpay_payment_id,   // PayU payment id equivalent
            status: "success",
            amount: formData.amount,
            productinfo: "Recharge",
            firstname: formData.firstname,
            email: formData.email,
            phone: formData.phone,
            hash: res.razorpay_signature,         // similar to PayU hash
            bank_ref_num: res.razorpay_order_id,  // order reference
            payment_source: "razorpay"
          };
          const response = await axios.post('/recharge/services/bazaarCallback', payuLikeResponse);
          const { status, message } = response.data;
          if (status) {
            swal("Success", message, "success");
          }
        } catch (err) {
          swal("Error", "Payment verification failed", "error");
        }
      },
      modal: {
        ondismiss: async function () {
          const response = await axios.post("/recharge/services/failedBazaarCallback", {
            txnid: formData.txnid
          });
          const { status, message } = response.data;
          if (status) {
            swal("Error", message, "error");
          }
        }
      },
      prefill: {
        name: formData.firstname,
        email: formData.email,
        contact: formData.phone,
      },
      theme: {
        color: "#3399cc",
      },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  }, [autoSubmit, formData]);

  return null; // no UI needed
};

export default PayUForm;
